enum PreferenceUpdateLocation {
    CharacterListing,
    CharacterBuilder,
    CharacterSheet,
}

export default PreferenceUpdateLocation;
